import React from 'react';

const RecentMilestones = () => (
  <div className="card-temple">
    <h3 className="text-2xl font-bold text-saffron mb-6">
      VI. Recent Milestones of Spiritual and Physical Renewal
    </h3>
    <p className="text-gray-700 mb-4 leading-relaxed">
      Continuing this legacy of dedication, the <strong className="font-black text-gray-900">temple pond</strong> was recently restored, a vital 
      project made possible by the contribution from <strong className="font-black text-gray-900">Sri S J Purushottama Prabhu</strong>.
    </p>
    <p className="text-gray-700 mb-6 leading-relaxed">
      Furthermore, the community was blessed to witness a moment of profound spiritual significance: the holy{' '}
      <strong className="font-black text-gray-900">Paduka sthapana</strong> (consecration of the sacred sandals) of the padukas of <strong className="font-black text-gray-900">HH Shrimath 
      Sukrathindra Thirtha Swamiji</strong> and <strong className="font-black text-gray-900">HH Shrimath Sudhindra Thirtha Swamiji</strong> on{' '}
      <strong className="font-black text-gray-900">May 7, 2023</strong>, by <strong className="font-black text-gray-900">HH Shrimath 
      Samyamindra Thirtha Swamiji</strong>, reaffirming the temple&apos;s enduring link to the spiritual lineage 
      of the Kashimath Samsthan.
    </p>
    <p className="text-gray-700 mb-6 leading-relaxed">
      The two sets of Padukas were gifted to the temple by the family of <strong className="font-black text-gray-900">Sri Nagendra Hari Bhat from 
      Gosripuram, Cochin</strong> - who received them directly from the holy hands of both the Swamijis on the 
      very same day in <strong className="font-black text-gray-900">February 1949</strong>, in consideration for their devoted service to the Samsthan. 
      Since then, daily prayers and Arathi was performed by the family till the date the Padukas were handed over.
    </p>
    
    <div className="grid md:grid-cols-2 gap-6 mt-8">
      <div className="text-center">
        <img
          src="https://customer-assets.emergentagent.com/job_krishna-temple/artifacts/82a5u8mp_paduka.png"
          alt="Paduka Sthapana ceremony"
          className="mx-auto max-w-full h-auto rounded-lg shadow-temple lotus-border"
        />
      </div>
      <div className="text-center">
        <img
          src="https://customer-assets.emergentagent.com/job_krishna-temple-1/artifacts/xhb6vp4a_Untitled%20design_20251006_174732_0000.png"
          alt="Temple sacred image"
          className="mx-auto max-w-full h-auto rounded-lg shadow-temple lotus-border"
        />
      </div>
    </div>
    
    <div className="mt-8 text-center">
      <img
        src="https://customer-assets.emergentagent.com/job_krishna-temple-1/artifacts/3k66amac_Untitled%20design_20251007_181127_0000.png"
        alt="Holy Padukas ceremonial display"
        className="mx-auto max-w-full h-auto rounded-lg shadow-temple lotus-border mb-6"
      />
    </div>
    
    <div className="mt-8 text-center">
      <img
        src="https://customer-assets.emergentagent.com/job_krishna-gallery/artifacts/p30mw838_1000003714.jpg"
        alt="Paduka Sthapana ceremony being performed by HH Shrimath Samyamindra Thirtha Swamiji"
        className="mx-auto max-w-full h-auto rounded-lg shadow-temple lotus-border"
      />
      <p className="text-sm text-gray-600 mt-2">HH Shrimath Samyamindra Thirtha Swamiji performing the Arathi during the Paduka Sthapana</p>
    </div>
    
    <div className="mt-8 text-center">
      <a
        href="https://youtu.be/IUWfp6gZBZg?feature=shared"
        target="_blank"
        rel="noopener noreferrer"
        className="btn-temple inline-block"
        data-testid="temple-pond-video-link"
      >
        Temple Pond Restoration - Watch Video
      </a>
    </div>
    
    <div className="mt-12">
      <h4 className="text-xl font-bold text-saffron mb-4">
        Agrashaala Renovation
      </h4>
      <p className="text-gray-700 mb-4 leading-relaxed">
        As a part of The Punaprathishta Shatabdi Mahotsav of Sree Rajagopala Krishnaswamy, the renovation of the Southern Agrashaala of the temple (which was built around 90 years ago) began in May 2025. The work has currently reached its final stage aligning with the plan to add a Paada Pooja Hall as the first floor. The renovation is taking place with the blessings of Sri Hari – Guru and the generous support of the Samajbandhavs according to the vaastu specifications. The plan for renovation includes two floors for the agrashaala. The work is expected to get completed before Utthaana Dwadashi this year. Currently, there is a requirement of around 15 Lakh Rupees for the work to proceed smoothly. We expect a wholehearted support from all who wish to be a part of this auspicious task.
      </p>
    </div>
  </div>
);

export default RecentMilestones;
